import { render, staticRenderFns } from "./InTaskLetterEditor.vue?vue&type=template&id=7d22ef95&"
import script from "./InTaskLetterEditor.vue?vue&type=script&lang=ts&"
export * from "./InTaskLetterEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports